<template>
    <div style="min-height: 100vh;background: #F9F9FF;overflow-x: hidden;width: 100%">
        <CommonHeader/>
        <div class="container" style="min-height: calc(100vh - 56px - 88px);">
            <a-row>
                <a-col class="mt-3 mb-3" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>个人项目</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </a-row>
            <a-card>
            <a-row>
                <a-col class="mt-3 mb-3" :span="24">
                    <ul>
                        <li>
                            <!--<a href="javascript:;" @click="goInfo(1)">-->
                            <router-link :to="{name: 'OrderInfo'}" >
                                订单信息
                            </router-link>
                            <!--</a>-->
                        </li>
                        <li>
                            <router-link :to="{name: 'PayInfo'}" >
                                支付记录
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'SignOrder'}" >
                                项目信息
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'OrderInfo'}" >
                                发票管理
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'SignInfo'}" >
                                我的收藏
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'SignInfo'}" >
                                我的质疑
                            </router-link>
                        </li>
                    </ul>
                </a-col>
                <a-col class="mt-3 mb-3" :span="24">
                    <router-view></router-view>
                </a-col>
            </a-row>
            </a-card>
        </div>
        <CommonFooter/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import SockJS from 'sockjs-client'
    import Stomp from 'webstomp-client'
    import CommonHeader from './common/CommonHeader'
    import CommonFooter from './common/CommonFooter'

    export default {
        components: {
            CommonHeader,
            CommonFooter,
        },
        created() {
            console.log("this.$store.getters")
            console.log(this.$store.getters)
            this.userName = this.$store.getters.nickname
        },
        beforeDestroy() {
            // this.disconnect();断开webSocket 服务端
        },
        data() {
            return {
                data: [],
                userName: '',
                stopDate: '',
                orgName: '',
                id: this.$route.query.id,
                announce: '',
            }
        },
        methods: {
            initData() {
                let that = this
                this.$http.get('/api/v1/supplier/announce/getAnnounce.json?announceId=' + this.id).then(function (res) {
                    if (res.result) {
                        that.announce = res.result
                        console.log(that.announce)
                    }
                })
            },
            goInfo(value) {
                console.log(value)

            }
        }
    };
</script>
<style lang="less" scoped>
    .text-header {
        text-align: center;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 24px;
    }

    .text-header span {
        flex: 1;
    }

    /deep/ .p-0 .ant-card-body {
        padding: 0;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }

    .ant-input {
        width: 200px;
    }
    ul {
        font-size: 15px;
    }
    ul li {
        display: block;
        padding-bottom: 50px;
    }
</style>